export enum ChannelCode {
    FSLS = 'FSLS', // File System LiSt
    HSTS = 'HSTS', // HoSTS List
    SHEL = 'SHEL', // SHELl
    GTRC = 'GTRC', // Goog device TRaCer
    ATRC = 'ATRC', // Appl device TRaCer
    WDAP = 'WDAP', // WebDriverAgent Proxy
    QVHS = 'QVHS', // Quicktime_Video_Hack Stream
}
